import { t } from "i18next";
import { shallowEqual, useSelector } from "react-redux";
import { userFullname, userProfileImage } from "store/user/userSelectors";
import DashboardCard from "widgets/cards/dashboard";
import CircleButton from "widgets/controls/buttons/circle-button";
import { GoArrowRight } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { MenuRoutePaths } from "models/constants/routes";
import { useDefaultImages } from "providers/default-image-provider";

const Profile = () => {
  const { defaultAvatar } = useDefaultImages();
  const avatar = useSelector(userProfileImage, shallowEqual);
  const fullname = useSelector(userFullname, shallowEqual);
  const navigate = useNavigate();

  const handleRoute = () => {
    navigate(`/admin${MenuRoutePaths.PROFILE}`);
  };
  return (
    <DashboardCard
      title={t("dashboard.card.profile.title")}
      bgColor="50"
      textColor="white"
      extra="h-full"
    >
      <div className="flex-grow"></div>
      <div className="flex flex-col gap-2">
        <img
          className="h-[80px] w-[80px] rounded-full border-4 border-text-50"
          src={avatar || (defaultAvatar as string)}
          alt=""
        />
        <div className="heading-lg text-white">{fullname}</div>
      </div>
      <div className="absolute bottom-4 right-2">
        <CircleButton
          label={t("dashboard.card.action", { context: "profile" })}
          size="xs"
          variant="ghost"
          color="white"
          icon={GoArrowRight}
          iconPosition="right"
          onClick={handleRoute}
        />
      </div>
    </DashboardCard>
  );
};

export default Profile;
